import React from 'react';
import QuizCreatePage from '../../components/quiz/QuizCreatePage ';

const CreateQuizPage = () => {
  return (
    
      <QuizCreatePage />
    
  );
};

export default CreateQuizPage;
